<form
  method="get"
  class="form"
  role="search"
  aria-label="Suche"
  action="/suche/"
  data-suggest-api="/api/search/suggest"
  [class.input-inpage]="inpage"
>
  <label
    class="search-form__label"
    for="search-form-header-desktop"
    #inputLabel
  >
    <hdi-input
      #inputElement
      [type]="inputType"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [inpage]="inpage"
      [class.input-inpage]="inpage"
      [hasError]="hasError"
      (handleInputChange)="inputChange($event)"
    ></hdi-input>
    <span [ngClass]="showCloseIcon ? 'close__search' : 'nav__search'">
      <hdi-icon
        [color]="
          showCloseIcon && hasError
            ? iconColorError
            : showCloseIcon && !hasError
              ? iconColor
              : undefined
        "
        [iconName]="showCloseIcon ? 'circle-xmark' : 'magnifying-glass'"
        [iconPrefix]="'far'"
        (click)="clearInput()"
        (keydown)="handleKeyDown($event)"
      ></hdi-icon>
    </span>
  </label>
</form>
